class TSHeader extends HTMLElement {
  constructor() {
    super(),
      (this.headerHeight = this.getBoundingClientRect().height),
      (this.headerGroup = document.querySelector(".ts-header-group")),
      (this.allAnnouncementsHeight = Math.max(
        this.headerGroup.offsetHeight - this.offsetHeight,
        1
      )),
      (this.mobileMenu = this.querySelector("#TSMobileMenu")),
      (this.enablePredictive =
        this.mobileMenu.getAttribute("data-predictive") === "true"),
      (this.scrollPosition = 0),
      this.calcHeader(),
      this.setupScrollEvents(),
      this.setupClickEvents(),
      this.setupSwipeEvents(),
      this.enablePredictive &&
        (this.setupFocusEvents(),
        this.setupSubmitEvents(),
        this.setupOnInputEvents());
  }
  calcHeader() {
    new ResizeObserver(() => {
      (this.headerHeight = this.getBoundingClientRect().height),
        document.documentElement.style.setProperty(
          "--header-height",
          `${this.headerHeight}px`
        ),
        (this.allAnnouncementsHeight = Math.max(
          this.headerGroup.offsetHeight - this.offsetHeight,
          1
        )),
        this.classList.toggle(
          "sticky",
          window.scrollY >= this.allAnnouncementsHeight
        );
    }).observe(this);
  }
  predictiveChange(query) {
    if (query === "") {
      (this.querySelector(".ts-header__predictive-results").innerHTML = ""),
        (this.mobileMenu.querySelector(".ts-predictive__content").innerHTML =
          null);
      return;
    }
    fetch(
      `/search/suggest?q=${encodeURIComponent(
        query.trim()
      )}&resources[type]=product,collection&section_id=ts-predictive-results`
    )
      .then((response) => {
        if (!response.ok) {
          (this.querySelector(".ts-header__predictive-results").innerHTML = ""),
            (this.mobileMenu.querySelector(
              ".ts-predictive__content"
            ).innerHTML = null);
          return;
        }
        return response.text();
      })
      .then((response) => {
        const responseMarkup = new DOMParser().parseFromString(
          response,
          "text/html"
        );
        console.log(responseMarkup);
        (this.mobileMenu.querySelector(".ts-predictive__content").innerHTML =
          responseMarkup.querySelector(".ts-predictive__content").innerHTML),
          (this.querySelector(".ts-header__predictive-results").innerHTML =
            responseMarkup.querySelector(".ts-predictive__content").innerHTML);
      })
      .catch((error) => {
        console.log("Something going wrong while fetch predictive", error);
      });
  }
  setupClickEvents() {
    this.addEventListener("click", (e) => {
      if (e.target.hasAttribute("data-trigger"))
        switch (e.target.dataset.trigger) {
          case "mega-on":
            const menuItem = e.target.closest(".ts-header__menu-item");
            let isOpening = !1;
            menuItem.classList.contains("active") ||
              (this.querySelector(
                ".ts-header__menu-item.active"
              )?.classList.remove("active"),
              (isOpening = !0)),
              menuItem.classList.toggle("active", isOpening);
            break;
          case "mega-off":
            this.querySelector(
              ".ts-header__menu-item.active"
            )?.classList.remove("active");
            break;
          case "menu":
            this.toggleMenu();
            break;
          case "open-search":
            e.preventDefault(),
              this.querySelector(".ts-header__predictive").classList.add(
                "active"
              );
            break;
          case "close-search":
            this.querySelector(".ts-header__predictive").classList.remove(
              "active"
            );
            break;
          case "menu-back":
            this.querySelector(".ts-menu__item.active").classList.remove(
              "active"
            );
            break;
          case "menu-more":
            e.target.closest(".ts-menu__item").classList.toggle("active");
            break;
        }
      e.target.classList.contains("ts-predictive__tab") &&
        this.querySelectorAll(".ts-predictive__results-wrapper").forEach(
          (results) => {
            results.setAttribute("active-tab", e.target.dataset.tab);
          }
        );
    }),
      document.addEventListener("click", (e) => {
        e.target.closest(".ts-header__menu-item.active") ||
          this.querySelector(".ts-header__menu-item.active")?.classList.remove(
            "active"
          ),
          e.target.closest(".ts-menu__item.active") ||
            this.querySelector(".ts-menu__item.active")?.classList.remove(
              "active"
            ),
          !e.target.closest(".ts-menu__search-results") &&
            !e.target.closest(".ts-menu__search-form") &&
            this.mobileMenu.classList.remove("predictive-open");
      });
  }
  setupScrollEvents() {
    window.addEventListener("scroll", () => {
      this.classList.toggle(
        "sticky",
        window.scrollY >= this.allAnnouncementsHeight
      );
    });
  }
  setupFocusEvents() {
    this.mobileMenu
      .querySelector("input[type='search']")
      .addEventListener("focus", () => {
        this.mobileMenu.classList.add("predictive-open");
      });
  }
  setupSubmitEvents() {
    this.addEventListener("submit", (e) => {
      e.preventDefault();
    });
  }
  setupOnInputEvents() {
    this.querySelectorAll("input[type='search']").forEach((input) => {
      input.addEventListener(
        "input",
        debounce((e) => {
          this.predictiveChange(e.target.value);
        }, 500).bind(this)
      );
    });
  }
  setupSwipeEvents() {
    let touchStartY = 0,
      currentY = 0,
      distanceMoved = 0;
    this.mobileMenu.addEventListener("touchstart", (e) => {
      touchStartY = e.changedTouches[0].screenY;
    }),
      this.mobileMenu.addEventListener("touchend", () => {
        const subPopupClosed =
          !this.mobileMenu.querySelector(".ts-menu__item.active") &&
          !this.mobileMenu.querySelector(".ts-country.open") &&
          !this.mobileMenu.classList.contains("predictive-open");
        distanceMoved > 80 && subPopupClosed
          ? this.toggleMenu()
          : (this.mobileMenu.querySelector(
              ".ts-menu__wrapper"
            ).style.transform = "translate(-50%, 0px)"),
          (distanceMoved = 0);
      }),
      this.mobileMenu.addEventListener("touchmove", (e) => {
        (currentY = e.changedTouches[0].screenY),
          (distanceMoved = currentY - touchStartY);
        const subPopupClosed =
          !this.mobileMenu.querySelector(".ts-menu__item.active") &&
          !this.mobileMenu.querySelector(".ts-country.open") &&
          !this.mobileMenu.classList.contains("predictive-open");
        distanceMoved > 0 &&
          subPopupClosed &&
          (this.mobileMenu.querySelector(
            ".ts-menu__wrapper"
          ).style.transform = `translate(-50%, ${Math.floor(
            distanceMoved / 2
          )}px)`);
      });
  }
  toggleMenu() {
    (this.mobileMenu.querySelector(".ts-menu__wrapper").style.transform = null),
      this.mobileMenu.classList.toggle("open"),
      this.togglePageScroll(this.mobileMenu.classList.contains("open")),
      this.mobileMenu.classList.contains("open") &&
      this.scrollPosition >= this.allAnnouncementsHeight
        ? this.classList.add("sticky-menu")
        : this.classList.remove("sticky-menu");
  }
  togglePageScroll(isOpen = !1) {
    isOpen
      ? ((this.scrollPosition = window.scrollY),
        (document.body.style.overflow = "hidden"),
        (document.body.style.position = "fixed"),
        (document.body.style.top = `-${this.scrollPosition}px`),
        (document.body.style.width = "100%"))
      : (document.body.style.removeProperty("overflow"),
        document.body.style.removeProperty("position"),
        document.body.style.removeProperty("top"),
        document.body.style.removeProperty("width"),
        window.scrollTo(0, this.scrollPosition));
  }
}
customElements.define("ts-header", TSHeader);
